"use client";

import { XIcon } from "lucide-react";

import { Link } from "@/shared.i18n/navigation";
import { PrimNavigationMenu } from "@/shared-web.ui/prim.navigation-menu";
import { PrimSheet } from "@/shared-web.ui/prim.sheet";
import { Box } from "@/shared-web.ui/ui.box";
import { Flex } from "@/shared-web.ui/ui.flex";
import { IconButton } from "@/shared-web.ui/ui.icon-button";
import { CartButton } from "@/stf.m.checkout/feat.cart";
import { PrimHeader } from "@/stf.ui/prim.header";
import { AppContainer } from "@/stf.ui/ui.app-container";

import { DesktopSwitch, MobileSwitch } from "../feat.theme-switch";
import { UserButtonWithNavbar } from "../feat.user";

const MainNavbar = () => {
  return (
    <nav>
      <PrimHeader.MobileNavbarHeader>
        <PrimHeader.HomeLogo />
        <PrimSheet.Close asChild>
          <IconButton
            color="gray"
            radius="full"
            variant="outline"
            screenReaders="Close sidebar"
          >
            <XIcon />
          </IconButton>
        </PrimSheet.Close>
      </PrimHeader.MobileNavbarHeader>
      <PrimHeader.MobileNavbarBody
        className={`
          text-4 text-gray-11
          hover:text-gray-12
        `}
      >
        <PrimSheet.Close
          asChild
          className="flex justify-start"
        >
          <Link href="/">Subscriptions</Link>
        </PrimSheet.Close>
        <PrimSheet.Close
          asChild
          className="flex justify-start"
        >
          <Link href="/blog">Blogs</Link>
        </PrimSheet.Close>
        <MobileSwitch />
      </PrimHeader.MobileNavbarBody>
    </nav>
  );
};

const MobileHeader = () => {
  return (
    <PrimHeader.HeaderComp className="md:hidden">
      <PrimHeader.MobileNavbarRoot>
        <AppContainer>
          <Flex align="center" direction="row" justify="between">
            <Flex>
              <PrimSheet.Root>
                <PrimSheet.Title hidden>Sidebar</PrimSheet.Title>
                <PrimSheet.Trigger asChild>
                  <PrimHeader.MenuIcon screenReaders="Open sidebar" />
                </PrimSheet.Trigger>
                <PrimSheet.Content className="w-screen" disablePadding side="left">
                  <PrimHeader.MobileNavbarContent tab="main">
                    <MainNavbar />
                  </PrimHeader.MobileNavbarContent>
                </PrimSheet.Content>
              </PrimSheet.Root>
            </Flex>
            <Box
              className={`
                absolute left-1/2 top-1/2 -translate-x-1/2
                -translate-y-1/2 text-inherit
              `}
            >
              <Link href="/">
                <PrimHeader.HomeLogo />
              </Link>
            </Box>
            <Flex gap="5">
              <Link href="/cart" prefetch>
                <CartButton />
              </Link>
              <UserButtonWithNavbar />
            </Flex>
          </Flex>
        </AppContainer>
      </PrimHeader.MobileNavbarRoot>
    </PrimHeader.HeaderComp>
  );
};

const { navigationMenuTriggerStyle } = PrimNavigationMenu;

const DesktopHeader = () => {
  return (
    <PrimHeader.HeaderComp
      className={`
        hidden
        md:flex
      `}
    >
      <AppContainer>
        <Flex align="center" direction="row" gap="8" justify="between">
          <Flex>
            <Link href="/">
              <PrimHeader.HomeLogo />
            </Link>
          </Flex>
          <Flex direction="row" flexGrow="1" justify="start">
            <PrimNavigationMenu.Root
              delayDuration={75}
            >
              <PrimNavigationMenu.List>
                <PrimNavigationMenu.Item>
                  <Link
                    href="/"
                    className={navigationMenuTriggerStyle()}
                  >
                    Subscriptions
                  </Link>
                </PrimNavigationMenu.Item>
                <PrimNavigationMenu.Item>
                  <Link
                    href="/blog"
                    className={navigationMenuTriggerStyle()}
                  >
                    Blogs
                  </Link>
                </PrimNavigationMenu.Item>
                <PrimNavigationMenu.Item>
                  <DesktopSwitch />
                </PrimNavigationMenu.Item>
              </PrimNavigationMenu.List>
            </PrimNavigationMenu.Root>
          </Flex>
          <Flex gap="5">
            <Link href="/cart" prefetch>
              <CartButton />
            </Link>
            <UserButtonWithNavbar />
          </Flex>
        </Flex>
      </AppContainer>
    </PrimHeader.HeaderComp>
  );
};

const Header = () => {
  return (
    <>
      <MobileHeader />
      <DesktopHeader />
    </>
  );
};

export { Header };
